import { EnhancedFieldConfig } from '../../types/form/schema.types';
import { validateRequired } from '../Utils';
import { YES_NO_OPTIONS } from './constants';

export interface YesNoRadioOptions {
  name: string;
  label: string;
  disabled: boolean;
  validationMessage: string;
  isInvalid?: (value: unknown) => boolean;
}

export const createYesNoRadio = ({
  name,
  label,
  disabled,
  validationMessage,
  isInvalid,
}: YesNoRadioOptions): EnhancedFieldConfig => ({
  type: 'radio',
  name,
  label,
  options: [...YES_NO_OPTIONS],
  required: true,
  validate: (value: unknown): string | undefined =>
    (isInvalid?.(value) ?? Boolean(validateRequired(value, label)))
      ? validationMessage
      : undefined,
  disabled,
});
